import {_} from "vue-underscore";

export const FlowGeneratorMixin = {
  methods: {
    isMatchWhen(model, when) {
      if (_.isArray(when)) {
        for (let i = 0; i < when.length; i++) {
          if (_.isMatch(model, when[i])) {
            return true
          }
        }
        return false
      } else {
        return _.isMatch(model, when)
      }
    }
  }
};

export const ComponentWithModelMixin = {
  props: {
    value: {
      default: undefined,
      description: "set v-model value from parent component"
    },
  },
  watch: {
    'model': {
      handler: function (val) {
        this.emitter(val)
      },
      deep: true
    },
    'value': function() {
      this.loadModel()
    }
  },
  data() {
    return {
      model: undefined,
    }
  },
  mounted() {
    this.loadModel()
  },
  methods: {
    emitter(val) {
      this.$emit("input", val)
    },
    submit() {
      this.isFlowValid()
      this.$emit("submit", this.model)
    },
    loadModel() {
      if (this.value !== undefined) {
        this.model = this.value;
      }
    }
  }
}

export const StepperValidationMixin = {
  data() {
    return {
      validationSteps: {}
    }
  },
  methods: {
    updateValidState(stepKey, isValid) {
      this.validationSteps[stepKey] = isValid
    },
    isFlowValid() {
      const validationStates = _.values(this.validationSteps)
      return _.every(
        validationStates,
        valid => valid === true
      )
    },
  }
}